import {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';

import {types as defaultTypes} from '../../../../utils/settings';

import iconStyles from '../../../../styles/base_components/Icon.module.scss';
import styles from '../../../../styles/case/Type.module.scss';
import {useSelector} from "react-redux";
import {selectTypes} from "../../../../features/types.slice";

const Wrapper = styled.div`
  &&& p {
    color: ${props => props.matched ? '#F3F6F7' : 'rgba(243, 246, 247, 0.5)'}
  }
`;

/**
 * @param {string} props.type keyword
 * @param {boolean} props.matched
 * @param {function} props.onClick
 */
function Type(props) {
  const pRef = useRef(null);
  const [width, setWidth] = useState('50px');
  const userTypes = useSelector(selectTypes);

  useEffect(() => {
    if (!pRef.current) return;

    const textWidth = pRef.current && pRef.current.offsetWidth;
    if (textWidth > 50) setWidth(textWidth + 'px');
  }, [pRef.current?.offsetWidth]);

  return (
    <Wrapper
      className={iconStyles.icon + ' ' + styles.type}
      style={{width: width}}
      matched={props.matched}
      onClick={props.onClick}
    >
      <div>
        <img src={props.matched ?
          defaultTypes[props.type]?.active || userTypes[props.type]?.active || defaultTypes['default'].active :
          defaultTypes[props.type]?.inactive || userTypes[props.type]?.inactive || defaultTypes['default'].inactive
        } alt={props.type}/>
      </div>
      <div>
        <p ref={pRef}>{defaultTypes[props.type]?.name || userTypes[props.type]?.name || props.type}</p>
      </div>
    </Wrapper>
  );
}

export default Type;